import {IRouteStore} from '../../router/routing.infra';

export interface ILoginCallbackStore extends IRouteStore {
    dispose(): void;
}

export class LoginCallbackStore implements ILoginCallbackStore {
    dispose(): void {}
}
